import { DeliveryDatesEffects } from './replacement.delivery.dates.effect';
import { SelectedEffects } from './selected.effect';

export const ProductDetailsEffects = [DeliveryDatesEffects, SelectedEffects];

export * from './replacement.delivery.dates.effect';
